import { ColumnForSelection } from '../../../shared/import/column-for-selection';
import { VarianceFormulaBaseLine } from './variance-formula-baseline';

export enum RefVolumeBasis {
    OldColumnValue = 0,
    AverageColumnValue = 1,
}

export enum FormulaItemType {
    Other,
    OldFormComp,
    NewFormComp,
}

export class FormulaItem {
    formCompIx: number | null;
    type: FormulaItemType;
    text: string;
};
 
export class FormCompVarianceLine {
    formCompIx: number;
    formCompName: string;
    newFormulaPart: FormulaItem[];
    oldFormulaPart: FormulaItem[];
};

export class ReferenceSettings {
    public basis: RefVolumeBasis;
    public columns: ColumnForSelection[];
    public oldControlValue: string;
    public newControlValue: string;
    public outcomeName: string;
    public maxPerc: number;
    public varianceFormulaBaseLine: VarianceFormulaBaseLine;

    public oldBaseLine: FormCompVarianceLine[] | null;
    public newBaseLine: FormCompVarianceLine[] | null;
    public canonical: FormCompVarianceLine[] | null;
}